/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';
import Cookies from 'js-cookie';
import _ from 'lodash';

Vue.use(Vuex);

const COOKIE_NAME = 'wha';

export default new Vuex.Store({
  state: {
    isLoading: false,
    isLoggedIn: !!Cookies.get(COOKIE_NAME),
    user: {
      isAdmin: false,
    },
  },
  mutations: { // supports sync only
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setUserContext(state, user) {
      // initialize all empty arrays and objects
      user.socialMedia = user.socialMedia || [];
      user.emergencyContacts = user.emergencyContacts || [];
      user.uploads = user.uploads || {};
      user.uploads.passport = user.uploads.passport || {};
      user.uploads.driversLicense = user.uploads.driversLicense || {};
      user.uploads.certifications = user.uploads.certifications || [];
      user.uploads.stateLicenses = user.uploads.stateLicenses || [];
      user.uploads.diplomas = user.uploads.diplomas || [];
      user.uploads.resume = user.uploads.resume || {};
      user.uploads.waivers = user.uploads.waivers || [];
      user.uploads.profilePic = user.uploads.profilePic || {};
      user.degrees = user.degrees || [];

      state.user = user;
    },
    setCookie(state, token) {
      state.isLoggedIn = true;
      // 86400 seconds in a day
      // 1 day / 14400 = 6 seconds
      // 1 day / 48 = 30 minutes
      Cookies.set(COOKIE_NAME, token, { expires: 1 / 24 });
    },
    logOut(state) {
      Cookies.remove(COOKIE_NAME);
      state.isLoggedIn = false;
    },
  },
  getters: {
    hasToken: () => { return () => { return !!Cookies.get(COOKIE_NAME); }; },
    token: () => { return () => { return Cookies.get(COOKIE_NAME); }; },
  },
  actions: { // supports async
  },
});
